module.exports = __webpack_public_path__ + "img/icon_signout_success@2x.25bf1257.png";